import type { IconData } from '@stacksjs/iconify-core'

export const ua1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"gold\" d=\"M0 0h512v512H0z\"/><path fill=\"#0057b8\" d=\"M0 0h512v256H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ua1x1
